import useApi from "./request";


export async function getConferenceShareInfoApi(conferenceId: string) {
    let { response, request } = useApi<any>(
       `/conference/share/info/${conferenceId}`,
        {
            method: "get",
        }
    );
    await request();
    return response;
  }

export async function touristsJoinConferenceApi(id: string) {
    let { response, request } = useApi<any>(
       `/conference/tourists/join`,
        {
            method: "post",
            data: {
                id,
            },
        }
    );
    await request();
    return response;
  }

export async function touristsLeaveConferenceApi(id: string) {
    let { response, request } = useApi<any>(
       `/conference/tourists/leave`,
        {
            method: "post",
            data: {
                id,
                conferenceId: id,
            },
        }
    );
    await request();
    return response;
  }

export async function getConferenceTouristsInfoApi(id: string) {
    let { response, request } = useApi<any>(
       `/conference/tourists/info`,
        {
            method: "post",
            data: {
                id,
            },
        }
    );
    await request();
    return response;
  }

export async function getConferenceUserAllApi(params: {
    id: string;
    pageNum: number;
    pageSize: number;
}) {
    let { response, request } = useApi<any>(
       `/conference/user/all`,
        {
            method: "post",
            data: {
                id: params.id,
                conferenceId: params.id,
                pageNum: params.pageNum,
                pageSize: params.pageSize,
            },
        }
    );
    await request();
    return response;
  }
